/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MinisitiResDto } from '../../models/minisiti-res-dto';

export interface PublicOrganizzazioneControllerGetOneOrganizzazioneBySlug$Params {
  slug: string;
}

export function publicOrganizzazioneControllerGetOneOrganizzazioneBySlug(
  http: HttpClient,
  rootUrl: string,
  params: PublicOrganizzazioneControllerGetOneOrganizzazioneBySlug$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<MinisitiResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    publicOrganizzazioneControllerGetOneOrganizzazioneBySlug.PATH,
    'get',
  );
  if (params) {
    rb.path('slug', params.slug, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MinisitiResDto>;
    }),
  );
}

publicOrganizzazioneControllerGetOneOrganizzazioneBySlug.PATH =
  '/public/organizzazione/slug/{slug}';
